import React, { useState, useEffect, useMemo } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Products.css';

const Products = ({ showAll = false, onViewAll, onSelectService }) => {
  const [categories, setCategories] = useState([]);
  const [filterCategoryId, setFilterCategoryId] = useState(null);
  const whatsappNumber = '905343437123';

  useEffect(() => {
    const categoriesRef = ref(database, 'productCategories');
    const unsubscribe = onValue(categoriesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data)
          .map(key => {
            const cat = data[key];
            const order = cat.order ?? 999;
            let subCategories = [];
            if (cat.subCategories && Object.keys(cat.subCategories).length > 0) {
              subCategories = Object.keys(cat.subCategories)
                .map(sid => {
                  const sub = cat.subCategories[sid];
                  const items = (sub.items && Object.keys(sub.items).length > 0)
                    ? Object.keys(sub.items).map(iid => ({
                        id: iid,
                        title: sub.items[iid].title || '',
                        description: sub.items[iid].description || ''
                      }))
                    : [];
                  return {
                    id: sid,
                    title: sub.title || '',
                    order: sub.order ?? 999,
                    items
                  };
                })
                .sort((a, b) => a.order - b.order);
            } else {
              const items = (cat.items && Object.keys(cat.items).length > 0)
                ? Object.keys(cat.items).map(iid => ({
                    id: iid,
                    title: cat.items[iid].title || '',
                    description: cat.items[iid].description || ''
                  }))
                : [];
              subCategories = items.length ? [{ id: 'genel', title: 'Genel', order: 0, items }] : [];
            }
            return {
              id: key,
              title: cat.title || '',
              order,
              subCategories
            };
          })
          .sort((a, b) => a.order - b.order);
        setCategories(list);
      } else {
        setCategories([]);
      }
    });
    return () => unsubscribe();
  }, []);

  const allProducts = useMemo(() => {
    const list = [];
    categories.forEach(cat => {
      (cat.subCategories || []).forEach(sub => {
        (sub.items || []).forEach(item => {
          list.push({
            ...item,
            categoryId: cat.id,
            categoryTitle: cat.title,
            subCategoryId: sub.id,
            subCategoryTitle: sub.title
          });
        });
      });
    });
    return list;
  }, [categories]);

  const filteredProducts = useMemo(() => {
    if (!filterCategoryId) return allProducts;
    return allProducts.filter(p => p.categoryId === filterCategoryId);
  }, [allProducts, filterCategoryId]);

  const shuffle = (arr) => {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const homeRandomProducts = useMemo(() => {
    if (allProducts.length <= 3) return allProducts;
    return shuffle(allProducts).slice(0, 3);
  }, [allProducts]);

  const displayProducts = showAll ? null : homeRandomProducts;
  const showViewAllButton = !showAll && allProducts.length > 0;

  const handleWhatsAppClick = (categoryTitle, itemTitle) => {
    const message = itemTitle
      ? `Merhaba, ${categoryTitle} - ${itemTitle} hakkında bilgi almak istiyorum.`
      : `Merhaba, ${categoryTitle} hakkında bilgi almak istiyorum.`;
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  if (categories.length === 0) {
    return (
      <section id="services" className="products">
        <div className="container">
          {!showAll && (
            <div className="section-header">
              <h2 className="section-title">İSO Belgeleri</h2>
              <p className="section-subtitle">İSO belgeleri ve kalite yönetim sistemi danışmanlığı.</p>
            </div>
          )}
          <div className="products-empty">
            <p>Henüz başlık veya hizmet eklenmemiş.</p>
          </div>
        </div>
      </section>
    );
  }

  if (showAll) {
    return (
      <section id="services" className="products products-page-layout">
        <div className="container">
          <div className="products-content products-content-full">
            <h2 className="products-content-category-title">İSO Belgeleri</h2>
            <p className="products-all-intro">Aşağıda İSO belgeleri listelenmektedir.</p>
            {categories.length > 0 && (
              <div className="products-toolbar">
                <div className="products-categories">
                  <button
                    type="button"
                    className={`products-cat-pill ${!filterCategoryId ? 'active' : ''}`}
                    onClick={() => setFilterCategoryId(null)}
                  >
                    Tümü
                  </button>
                  {categories.map((cat) => (
                    <button
                      key={cat.id}
                      type="button"
                      className={`products-cat-pill ${filterCategoryId === cat.id ? 'active' : ''}`}
                      onClick={() => setFilterCategoryId(cat.id)}
                    >
                      {cat.title}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div className="products-grid">
              {filteredProducts.map((item) => (
                <div
                  key={`${item.categoryId}-${item.subCategoryId}-${item.id}`}
                  className="product-card product-card-clickable"
                  onClick={() => onSelectService && onSelectService(item.categoryId, item.subCategoryId, item.id)}
                  onKeyDown={(e) => e.key === 'Enter' && onSelectService && onSelectService(item.categoryId, item.subCategoryId, item.id)}
                  role={onSelectService ? 'button' : undefined}
                  tabIndex={onSelectService ? 0 : undefined}
                >
                  <h4 className="product-card-title">{item.title}</h4>
                  {item.description ? (
                    <p className="product-card-description">{item.description}</p>
                  ) : null}
                  <button
                    type="button"
                    className="offer-btn"
                    onClick={(e) => { e.stopPropagation(); handleWhatsAppClick(item.categoryTitle, item.title); }}
                  >
                    Teklif Al
                  </button>
                  {onSelectService && <span className="product-card-link">Detay →</span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="services" className="products">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">İSO Belgeleri</h2>
          <p className="section-subtitle">İSO belgeleri ve kalite yönetim sistemi danışmanlığı.</p>
        </div>
        <div className="products-grid">
          {displayProducts.map((product) => (
            <div
              key={`${product.categoryId}-${product.id}`}
              className="product-card product-card-clickable"
              onClick={() => onSelectService && onSelectService(product.categoryId, product.subCategoryId, product.id)}
              onKeyDown={(e) => e.key === 'Enter' && onSelectService && onSelectService(product.categoryId, product.subCategoryId, product.id)}
              role={onSelectService ? 'button' : undefined}
              tabIndex={onSelectService ? 0 : undefined}
            >
              <h3 className="product-card-title">{product.title}</h3>
              {product.description ? (
                <p className="product-card-description">{product.description}</p>
              ) : null}
              <button
                type="button"
                className="offer-btn"
                onClick={(e) => { e.stopPropagation(); handleWhatsAppClick(product.categoryTitle, product.title); }}
              >
                Teklif Al
              </button>
              {onSelectService && <span className="product-card-link">Detay →</span>}
            </div>
          ))}
        </div>
        {showViewAllButton && (
          <div className="view-all-container">
            <button type="button" onClick={onViewAll} className="view-all-btn">
              Tüm hizmetleri görüntüle
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Products;
